module.exports={
	"Form": "FundingSourceEditManifest",
	"Scope": "FundingSource-Edit",
	"Descriptors":
	{
		"FundingSourceDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingSource-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingSource-Edit-Identity",
				"Group": "FundingSource-Edit-Identity"
			}
		},
		"FundingSourceDetails.FundingSourceAccountCode":
		{
			"Name": "Funding Source Account Code",
			"Hash": "FundingSource-Edit-FundingSourceAccountCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingSource-Edit-Identity",
				"Group": "FundingSource-Edit-Identity"
			}
		},
		"FundingSourceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "FundingSource-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details"
			}
		},
		"FundingSourceDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingSource-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details"
			}
		},
		"FundingSourceDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "FundingSource-Edit-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details"
			}
		},
		"FundingSourceDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingSource-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		},
		"FundingSourceDetails.IDFundingSource":
		{
			"Name": "IDFunding Source",
			"Hash": "FundingSource-Edit-IDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.GUIDFundingSource":
		{
			"Name": "GUIDFunding Source",
			"Hash": "FundingSource-Edit-GUIDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingSource-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingSource-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingSource-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingSource-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingSource-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingSource-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingSource-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingSource-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingSource-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingSource-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
